<template>
    <div>
       <HeaderTeam header="ตั้งค่า" :img_header="header_image" link_back="team"/>
       <MenuTeamSettingList/>
       <DayOffRestaurantList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/settings.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamSettingList from '@/components/menuadmin/team/teamsetting/MenuTeamSettingList.vue'
import DayOffRestaurantList from '@/components/menuadmin/team/teamsetting/DayOffRestaurantList.vue'
export default {
    name:'dayOffRestaurant',
    components:{
        HeaderTeam,
        MenuTeamSettingList,
        DayOffRestaurantList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>